<template>
  <v-card flat tile>
    <v-card-title>Consignor History</v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="consignorInvestments.pastAssets"
        class="mb-12 elevation-1"
        no-data-text="You have no past investments."
      >
        <template v-slot:item.mainImage="{ item }">
          <v-img
            max-width="100px"
            class="my-1"
            :src="item.mainImage"
          ></v-img>
        </template>

        <template v-slot:item.title="{ item }">
          <router-link :to="`/flip/${item.id}`">
            {{ item.title }}
          </router-link>
        </template>

        <template v-slot:item.projectedRoi="{ item }">
          {{ item.projectedRoi}}% ROI
        </template>

        <template v-slot:item.actualRoi="{ item }">
          {{ item.actualRoi}}% ROI
        </template>

      </v-data-table>
    </v-card-text>

  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'PastInvestments',

    computed: {
      ...mapGetters([
        'consignorInvestments'
      ])
    },

    data: () => ({
      headers: [
        {
          text: '',
          value: 'mainImage'
        },
        {
          text: 'Asset',
          value: 'title'
        },
        // {
        //   text: 'Shares Owned',
        //   value: 'sharesOwned'
        // },
        {
          text: 'Projected ROI',
          value: 'projectedRoi'
        },
        {
          text: 'Realized Shared ROI',
          value: 'actualRoi'
        }
      ]
    }),

    methods: {
    },

    async created() {
    }
  }
</script>
